import { Box, styled } from '@mui/material';

const Container = styled(Box)`
  display: flex;
  align-items: center;
  flex: 1;
  gap: 10px;
`;

export default Container;
